import { Container, Row, Col } from "react-bootstrap";
import { useOutletContext } from "react-router-dom";

import AdditionalLoanOverviewBanner from "../components/additional_loan_overview_banner";
import LoanInformation from "./loan_information";
import SupportSection from "./support_section";
import UpcomingInstallments from "./upcoming_installments";
import RecentTransactions from "./recent_transactions";
import DashboardSkeleton from "../components/dashboard_skeleton";
import NoLoanCard from "../components/no_loan_card";

export function LoanDashboard() {
  const { loanUUID, loanSummary, loading } = useOutletContext();

  if (loading) {
    return <DashboardSkeleton />;
  }

  if (!loanSummary) {
    return <NoLoanCard />;
  }

  return (
    <Container fluid className="py-2">
      <h1 className="text-2xl fw-bolder my-4">Dashboard</h1>

      <AdditionalLoanOverviewBanner loanUUID={loanUUID} loanSummary={loanSummary} />

      <Row className="g-3">
        <Col xs={12} md={9}>
          <LoanInformation loanUUID={loanUUID} loanSummary={loanSummary} />
        </Col>

        <Col xs={12} md={3}>
          <SupportSection fillHeight />
        </Col>

        <Col xs={12} md={8}>
          <RecentTransactions loanUUID={loanUUID} loanSummary={loanSummary} />
        </Col>

        {loanSummary?.totalOutstanding > 0 && (
          <Col xs={12} md={4}>
            <UpcomingInstallments loanUUID={loanUUID} />
          </Col>
        )}
      </Row>
    </Container>
  );
}
